import {
  CAROUSEL_CURRENT_SLIDE_CHANGED,
  CAROUSEL_PAUSED,
  CAROUSEL_UNPAUSED,
  CAROUSEL_VIDEO_PLAYING,
  CAROUSEL_VIDEO_PROGRESS,
} from '../actions';

const initialState = {
};

const mergeCarouselState = (state, carouselSliceId, nextState) => ({
  ...state,
  [carouselSliceId]: {
    ...state[carouselSliceId],
    ...nextState,
  },
});

const handleVideoActions = (state, action) => {
  switch (action.type) {
    case CAROUSEL_VIDEO_PLAYING:
      return mergeCarouselState(state, action.payload.carouselSliceId, {
        videoPlaying: true,
        videoDuration: action.payload.duration,
        videoCurrentTime: 0,
      });

    case CAROUSEL_VIDEO_PROGRESS:
      return mergeCarouselState(state, action.payload.carouselSliceId, {
        videoCurrentTime: action.payload.currentTime,
      });

    default:
      return state;
  }
};

const carousel = (state = initialState, action) => {
  switch (action.type) {
    case CAROUSEL_CURRENT_SLIDE_CHANGED:
      return mergeCarouselState(state, action.payload.carouselSliceId, {
        slideIndex: action.payload.slideIndex,
        videoPlaying: false,
        videoDuration: 0,
        videoCurrentTime: 0,
      });

    case CAROUSEL_PAUSED:
      return mergeCarouselState(state, action.payload.carouselSliceId, {
        paused: true,
      });

    case CAROUSEL_UNPAUSED:
      return mergeCarouselState(state, action.payload.carouselSliceId, {
        paused: false,
      });

    default:
      return handleVideoActions(state, action);
  }
};

export default carousel;
